import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./index.css";
import NewRelicScript from "./components/UtilComponents/NewRelicScript";

const rootContainer = document.getElementById("root")!;

const root = createRoot(rootContainer);
const persistor = persistStore(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NewRelicScript />
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
